/* ==========================================================================
   Sultana — WhatsApp ordering
   The store has no online checkout. Every "checkout" opens a WhatsApp chat
   with the order already written. Strings + number come from
   window.SultanaWA (layout/theme.liquid). Links carry a server-built href,
   so they still work if this file fails to load.
   ========================================================================== */
(function () {
  var cfg = window.SultanaWA;
  if (!cfg || !cfg.number) return;

  var isTouch = window.matchMedia('(pointer: coarse)').matches;

  function waUrl(text) {
    return 'https://wa.me/' + cfg.number + '?text=' + encodeURIComponent(text);
  }

  /* Open WhatsApp. On desktop a tab is opened synchronously in the click so
     popup blockers allow it, then pointed at wa.me once the message is ready. */
  function openWith(buildPromise) {
    var win = null;
    if (!isTouch) {
      try {
        win = window.open('', '_blank');
        if (win) win.opener = null;
      } catch (e) {}
    }
    return buildPromise.then(function (text) {
      var url = waUrl(text);
      if (win && !win.closed) win.location.href = url;
      else window.location.href = url;
    }).catch(function () {
      if (win) win.close();
    });
  }

  function absolute(url) {
    try { return new URL(url, window.location.origin).href; } catch (e) { return url; }
  }

  function cartMessage(cart) {
    var lines = [cfg.greeting, ''];
    cart.items.forEach(function (item, i) {
      var title = item.product_title;
      if (!item.product_has_only_default_variant && item.variant_title) title += ' (' + item.variant_title + ')';
      lines.push(i + 1 + '. ' + title);
      lines.push('   ' + cfg.quantity + ': ' + item.quantity);
      if (item.sku) lines.push('   SKU: ' + item.sku);
      lines.push('   ' + absolute(item.url));
    });
    if (cart.note) lines.push('', cfg.note + ': ' + cart.note);
    lines.push('', cfg.closing);
    return lines.join('\n');
  }

  function orderBag() {
    var root = (window.routes && window.routes.cart_url) || '/cart';
    /* The note textarea saves on a debounce — read what is typed right now */
    var noteField = document.querySelector('#Cart-note, #CartDrawer-Note');
    return fetch(root + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) throw new Error('empty');
        if (noteField && noteField.value.trim()) cart.note = noteField.value.trim();
        return cartMessage(cart);
      });
  }

  function productMessage(btn) {
    var data = {};
    try { data = JSON.parse(btn.querySelector('[data-s-wa-data]').textContent); } catch (e) {}
    var sectionId = btn.getAttribute('data-section-id');
    var form = document.getElementById('product-form-' + sectionId) ||
      (btn.closest('product-form') && btn.closest('product-form').querySelector('form'));
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = document.getElementById('Quantity-' + sectionId) ||
      document.querySelector('[form="product-form-' + sectionId + '"][name="quantity"]');
    var variantId = idInput && idInput.value;
    var variant = (data.variants && data.variants[variantId]) || null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var title = data.title || document.title;
    if (!data.single && variant) title += ' (' + variant.title + ')';
    var lines = [cfg.productGreeting, '', title];
    if (variant && variant.sku) lines.push('SKU: ' + variant.sku);
    if (qty > 1) lines.push(cfg.quantity + ': ' + qty);
    lines.push((data.url || window.location.href.split('?')[0]) + (variantId && !data.single ? '?variant=' + variantId : ''));
    lines.push('', cfg.closing);
    return lines.join('\n');
  }

  document.addEventListener('click', function (e) {
    var bagBtn = e.target.closest('[data-s-wa-order]');
    if (bagBtn) {
      e.preventDefault();
      if (bagBtn.getAttribute('aria-disabled') === 'true') return;
      bagBtn.classList.add('is-loading');
      openWith(orderBag()).then(function () { bagBtn.classList.remove('is-loading'); });
      return;
    }
    var productBtn = e.target.closest('[data-s-wa-product]');
    if (productBtn) {
      e.preventDefault();
      openWith(Promise.resolve(productMessage(productBtn)));
      return;
    }
    /* Any link that still points at Shopify checkout */
    var link = e.target.closest('a[href*="/checkout"]');
    if (link && link.origin === window.location.origin) {
      e.preventDefault();
      openWith(orderBag());
    }
  });

  /* Safety net: a form submitted with name="checkout" (app blocks, old markup) */
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') {
      e.preventDefault();
      openWith(orderBag());
    }
  }, true);

  /* Keep the bag button enabled/disabled as items are added or removed */
  function syncEmpty(count) {
    document.querySelectorAll('[data-s-wa-order]').forEach(function (b) {
      if (count > 0) b.removeAttribute('aria-disabled');
      else b.setAttribute('aria-disabled', 'true');
    });
  }
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (cart && typeof cart.item_count === 'number') syncEmpty(cart.item_count);
    });
  }
})();
